import { tap, map } from 'rxjs';
import { CrudServiceBase, TypeUtils } from '@utils';
import { httpService } from '@services/http';
import { logger } from '@services/logger';
import { ParkAreaAssesment } from './park-area-assesment.class';

export class ParkAreaAssesmentService extends CrudServiceBase<ParkAreaAssesment> {
	constructor(parkAreaId: string) {
		super(ParkAreaAssesment, `park-area/${parkAreaId}/park-area-assesment`);
	}

	getByAssesmentId(assesmentId: string) {
		return httpService.get<ParkAreaAssesment>(this.getUrl(), `by-assesment-id/${assesmentId}`).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.getByAssesmentId.name}]`, result)),
			map((entities) => TypeUtils.convert(ParkAreaAssesment, entities))
		);
	}
}
